import { Injectable } from '@angular/core';
import { ApiProvitoolService } from '@core/apis/api-provitool.service';
import { isArray } from '@core/helpers';
import { IAsyncTaskReport, ITask } from './async-task-constants';


@Injectable({
  providedIn: 'root'
})
export class LinktImportReport implements IAsyncTaskReport {
  constructor(private readonly apiProvitool: ApiProvitoolService){}

  private _formatLinktImportSuccess(detail): string {
    if (!detail || !Object.keys(detail).length) {
      return '';
    }
    let successString = '<ul>';
    detail.forEach(success => {
      successString += `
        <br><br>
        <a href="${this.apiProvitool.attachments.downloadUrl(success.attachment_id)}" class="btn btn-default" target="_blank">
          <i class="far fa-file-excel" aria-hidden="true"></i>
          Télécharger le rapport
        </a>
      `;
    });
    successString += '</ul>';
    return successString;
  }

  private _formatLinktImportError(detail): string{
    let errorString: string = '<ul>';
    if (!detail) {
      return '<ul><li>Erreur non reconnue.</li></ul>';
    }
    let errors = []
    if (isArray(detail)) {
      errors = detail;
    } else if (typeof detail.error === 'string') {
      try {
        const json = JSON.parse(detail.error.replace(/'/g, '"'));
        errors = Object.keys(json).map((key: string) => ({ error_type: key, error_detail: json[key] }));
      } catch (e) {
        errors = [{
          error_type: detail.error_type || 'UNKNOWN_ERROR',
          error_detail: detail.error
        }];
      }
    } else {
      return '<ul><li>Erreur non reconnue.</li></ul>';
    }

    errors.forEach(error => {
      errorString += '<li>';
      switch (error.error_type) {
        case 'INVALID_FILE_STRUCTURE':
          errorString += `Structure du fichier importé invalide :<br>`;
          if (error.error_detail && isArray(error.error_detail)) {
            errorString += `<ul><li>`;
            errorString += error.error_detail.join('</li>\n<li>');
            errorString += `</li></ul>`;
          }
          break;
        case 'SOURCE_FILE_IS_MISSING':
          errorString += `Aucun fichier n'a été reçu par le serveur.`;
          break;
        case 'INVALID_FILE_CONTENT':
          errorString += `Certaines lignes n'ont pas passé l'étape de validation.`;
          errorString += `
            <br><br>
            <a href="${this.apiProvitool.attachments.downloadUrl(error.attachment_id)}" class="btn btn-default" target="_blank">
              <i class="far fa-file-excel" aria-hidden="true"></i>
              Télécharger le rapport
            </a>
          `;
          break;
        default:
          if (error.error_detail && isArray(error.error_detail)) {
            errorString += `Une erreur est survenue: `;
            errorString += `<ul><li>`;
            errorString += error.error_detail.join('</li>\n<li>');
            errorString += `</li></ul>`;
          } else {
            errorString = 'Erreur non reconnue.';
          }
          break;
      }
      errorString += '</li>';
    });

    errorString += '</ul>';

    return errorString;
  }

  public generate(task: ITask): string {
    const detail = task.detail;

    if(task.status === 'success') {
      let htmlDetail: string = `<div>Import des liens opérateurs LINKT réussi.<br></div>`;
      htmlDetail += this._formatLinktImportSuccess(detail);
      return htmlDetail;
    } else {
      let htmlDetail: string = `<div>Échec de l'import des liens opérateurs LINKT</div>`;
      htmlDetail += this._formatLinktImportError(detail);
      return htmlDetail;
    }
  }
}
